import { Row } from 'antd'
import HomePageButton from 'app/components/UI-Elements/General/HomePageButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import * as React from 'react'

const RoleNotAuthorized: React.FC<PageProps> = ({ route }) => {
  const { tRoute } = useTranslation({ scope: route.key })

  return (
    <Row justify="center">
      <KCol card xs={24} md={18} lg={14}>
        <Row gutter={[0, 24]} className="text-center my-5">
          <KCol span={24}>
            <h3>{tRoute({ id: `title` })}</h3>
          </KCol>
          <KCol span={24}>
            <Icon iconStyles={{ width: 100, height: 100 }} type="dashboard" />
          </KCol>
          <KCol span={24} className="text-center">
            <p>{tRoute({ id: `content` })}</p>
          </KCol>
          <KCol span={24}>
            <HomePageButton />
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default RoleNotAuthorized
